import React, { Fragment, useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles } from "@mui/styles";
import {
  Grid,
  Toolbar,
  Alert,
  Typography,
  Box,
  List,
  ListItem,
  Divider,
  Dialog,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
  FormGroup,
  CssBaseline,
  Button,
} from "@mui/material";
import {
  Add,
  AccountCircleOutlined,
  CreditCardOutlined,
  MoreHoriz,
  DeleteOutline,
  PanoramaFishEye,
  RadioButtonChecked,
} from "@mui/icons-material";
import queryString from "query-string";
import axios from "axios";
import Moment from "moment";

import FrequentQuestions from "views/dialog/FrequentQuestions";
import NewCardLink from "views/dialog/NewCardLink";

import logoUsame from "assets/img/logo-Usame-web-color.png";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";
import typeCard from "assets/img/marcas-tarjetas.png";
import imgLoader from "assets/img/loading.gif";

import {
  AppBarStyle,
  cardBodyStyle,
  ButtonExit,
  ButtonStyle0,
  blackColor,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const style = {
  p: 0,
  width: "100%",
  maxWidth: 500,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  backgroundColor: "background.paper",
};

export default function AddCardLink(props) {
  const classes = useStyles();

  const [openFrequentQuestion, setOpenFrequentQuestion] = useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [rows, setRows] = useState(null);
  const [openNew, setOpenNew] = useState(false);
  const [Loader, setLoader] = useState(true);
  const [openDelete, setOpenDelete] = useState(false);
  const [openAcceptTerms, setOpenAcceptTerms] = useState(false);
  const [idDelete, setIdDelete] = useState("");
  const [alert, setAlert] = useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });
  const [state, setState] = React.useState({
    YES_termsConditions: false,
    YES_dataProtectionPolicies: false,
  });
  const [accept, setAccept] = useState(false);

  const { urlServices } = useContext(UrlServicesContext);

  const location = useLocation();
  const params = queryString.parse(location.search);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RowsDatas();
  }, []);

  const RowsDatas = async () => {
    try {
      const response = await axios.get(
        `${urlServices}clients-transaction/transaction/${params.transaction}`
      );

      if (response.status === 200) {
        const transformedRows = {
          ...response.data.data,
          productsJson: parseJsonArray(response.data.data.productsJson),
          client: {
            ...response.data.data.client, // Si necesitas otras propiedades de client
            prefix: JSON.parse(response.data.data.client.prefix), // Asigna prefix directamente
          },
        };

        setRows(transformedRows);

        if (!transformedRows.acceptTerms) {
          setOpenAcceptTerms(true);
        }
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setMensageSystem("Registro no encontrado.");
        setError(true);
      } else if (error.response?.status === 500) {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    } finally {
      setLoader(false);
    }
  };

  // Función para parsear cadenas JSON y asegurar que sean arrays
  const parseJsonArray = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return [];
    }
  };
  // Manejo común de errores
  const handleError = (error) => {
    if (error.response?.status === 404) {
      setMensageSystem("Registro no encontrado.");
      setError(true);
    } else if (error.response?.status === 500) {
      setMensageSystem("Error en la consulta con el servidor.");
      setError(true);
    } else {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Error al realizar la solicitud.");
      setError(true);
    }
    setLoader(false);
  };

  const selectCard = (clientsId, id) => () => {
    setAlert({ ...alert, openAlert: false });

    const dataValue = {
      clientsIdSelect: clientsId,
      select: 1,
      selectCard: true,
    };

    axios
      .put(`${urlServices}card-collection-client/${id}`, dataValue)
      .then((response) => {
        RowsDatas();
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const deleteCardValue = (id) => () => {
    setAlert({ ...alert, openAlert: false });
    setOpenDelete(true);
    setIdDelete(id);
  };

  const deleteCard = () => () => {
    setAlert({ ...alert, openAlert: false });

    const dataValue = {
      status: 0,
      select: 0,
    };

    axios
      .put(`${urlServices}card-collection-client/${idDelete}`, dataValue)
      .then((response) => {
        RowsDatas();
        setOpenDelete(false);
        setIdDelete("");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const submitAcceptSave = (data, value) => {
    const dataValue = {
      [data]: value,
    };

    axios
      .put(`${urlServices}clients-transaction/${rows.id}`, dataValue)
      .then((response) => {
        setOpenAcceptTerms(false);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const submitAccept = () => {
    let date = JSON.stringify({
      status: "accept",
      date: Moment().format("DD-MM-YYYY"),
    });

    submitAcceptSave("acceptTerms", date);
    setAccept(true);
  };

  const handleCloseFrequentQuestion = () => {
    setOpenFrequentQuestion(false); // Close the modal
  };

  const handleChangeCheckbox = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  const handleCloseDelete = () => () => {
    setOpenDelete(false);
  };

  const handleCloseOpenNew = () => {
    setOpenNew(false);
  };

  return (
    <Fragment>
      <AppBarStyle position="static">
        <Toolbar sx={{ minHeight: "50px !important" }}>
          <img
            src={logoUsame}
            alt="logoheader"
            style={{ width: 70, marginLeft: "5%" }}
          />
        </Toolbar>
      </AppBarStyle>
      <center>
        <Grid
          container
          spacing={2}
          className={classes.containerProfile}
          sx={{ width: "70%", margin: "10px 8px 30px 8px" }}
        >
          <Grid item xs={12} sm={12}>
            {error && <Alert severity="error">{mensageSystem}</Alert>}
          </Grid>
          {error ? (
            <Grid item xs={12} sm={12} sx={{ textAlign: "left", mb: 3 }}>
              <center>
                <img
                  alt="loaderGif"
                  src={noDataImg}
                  style={{ width: 300, marginTop: 50 }}
                />
                <br></br>
                <b style={{ fontSize: 18, margin: "5px 0 70px 0" }}>
                  No hay registros para mostrar
                </b>
              </center>
            </Grid>
          ) : (
            <>
              <Grid item xs={12} sm={12} sx={{ textAlign: "left", mb: 1 }}>
                <div className={classes.titleCardFilter}>
                  Cobros recurrentes{" "}
                  <span
                    style={{
                      float: "right",
                      fontSize: 12,
                      width: 140,
                      lineHeight: "normal",
                      marginTop: 3,
                    }}
                  >
                    <AccountCircleOutlined sx={{ verticalAlign: "middle" }} />{" "}
                    {rows && rows.client.name1 + " " + rows.client.lastName1}
                  </span>
                </div>
                <div className={classes.lineBottom}></div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Alert severity="info" sx={{ mb: 2 }}>
                  Registre su tarjeta de crédito o débito para el cobro
                  recurrente de su plan activo.
                </Alert>
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  fontSize={14}
                  sx={{ mb: 1, float: "left" }}
                  className={classes.titleCardFilter}
                >
                  Tarjetas registradas del usuario:{" "}
                  <ButtonStyle0
                    onClick={() => setOpenNew(true)}
                    endIcon={<Add />}
                    style={{ marginLeft: 12 }}
                  >
                    Agregar tarjeta
                  </ButtonStyle0>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: 1, mb: 6 }}>
                {Loader ? (
                  <img
                    src={imgLoader}
                    alt="loader"
                    style={{
                      width: 60,
                      objectFit: "contain",
                      marginTop: 25,
                    }}
                  />
                ) : Array.isArray(rows?.client?.cardCollection) &&
                  rows.client.cardCollection?.length > 0 ? (
                  <List sx={style} aria-label="tarjetas registradas">
                    {rows.client.cardCollection.map((card, index) => {
                      let transaction;
                      try {
                        transaction = JSON.parse(card.responseTransaction);
                      } catch (err) {
                        console.error("Error parsing transaction:", err);
                        return null; // evita render si JSON inválido
                      }

                      const cardNumber =
                        transaction?.subscription?.instrument[3]?.value ||
                        "****";
                      const cardCode =
                        transaction?.subscription?.instrument[5]?.value;
                      const expiryRaw =
                        transaction?.subscription?.instrument[6]?.value;
                      const expiryDate = expiryRaw
                        ? new Date(expiryRaw.trim())
                        : null;
                      const today = new Date();
                      const isExpired = expiryDate < today;

                      return (
                        <React.Fragment key={card.id || index}>
                          <ListItem
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                              width: "100%",
                              background: "#F9F9F9",
                              py: 2,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                fontWeight: 500,
                                color: "#000",
                              }}
                            >
                              <CreditCardOutlined sx={{ mr: 1 }} />
                              {cardNumber}
                              <MoreHoriz sx={{ mx: 0.5 }} />
                              <MoreHoriz sx={{ mx: 0.5 }} />
                              <MoreHoriz sx={{ mx: 0.5 }} />
                              {cardCode}
                              <Box
                                sx={{
                                  ml: "auto",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {!isExpired &&
                                  (card.select === 1 ? (
                                    <Button
                                      variant="outlined"
                                      size="small"
                                      sx={{
                                        color: "green",
                                        fontSize: 10,
                                        fontWeight: "bold",
                                      }}
                                      startIcon={
                                        <RadioButtonChecked
                                          sx={{
                                            cursor: "pointer",
                                            mx: 0.5,
                                            color: "green",
                                          }}
                                        />
                                      }
                                    >
                                      Activa
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="outlined"
                                      size="small"
                                      sx={{
                                        color: "gray",
                                        fontSize: 10,
                                        fontWeight: "bold",
                                        border: "1px solid gray",
                                      }}
                                      startIcon={
                                        <PanoramaFishEye
                                          sx={{ cursor: "pointer", mx: 0.5 }}
                                        />
                                      }
                                      onClick={selectCard(
                                        card.clientsId,
                                        card.id
                                      )}
                                    >
                                      Seleccionar
                                    </Button>
                                  ))}
                                <DeleteOutline
                                  onClick={deleteCardValue(card.id)}
                                  sx={{
                                    cursor: "pointer",
                                    color: "red",
                                    mx: 1,
                                  }}
                                />
                              </Box>
                            </Box>

                            <Typography
                              variant="subtitle2"
                              fontSize={12}
                              sx={{
                                color: card.select === 1 ? "green" : "red",
                                fontWeight: 500,
                              }}
                              className={classes.titleCardFilter}
                            >
                              {isExpired
                                ? "Caducada"
                                : card.select === 1
                                ? "Seleccionada"
                                : ""}
                            </Typography>
                          </ListItem>
                          <Divider component="li" />
                        </React.Fragment>
                      );
                    })}
                  </List>
                ) : (
                  <Alert severity="error" sx={{ width: 300, mt: 2 }}>
                    {" "}
                    NO HAY TARJETA REGISTRADA
                  </Alert>
                )}
              </Grid>
            </>
          )}
          <Grid item xs={12} sm={12} sx={{ mt: 8 }}>
            <Box
              component="img"
              src={typeCard}
              alt="franquicias"
              sx={{
                width: 170,
                float: "right",
                mx: 3,
                mt: 4,
              }}
            ></Box>
            <Box
              component="img"
              src="https://static.placetopay.com/placetopay-logo.svg"
              alt="paymentsCompany"
              sx={{
                width: 140,
                mx: 3,
                mt: 4,
                float: "right",
              }}
            ></Box>
          </Grid>
          <Grid container>
            <Grid item xs={12} sm={12} sx={{ my: 2 }}>
              <span
                onClick={() => setOpenFrequentQuestion(true)}
                style={{
                  fontSize: 12,
                  textTransform: "none",
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                  fontWeight: 500,
                  lineHeight: 1.75,
                  color: "#000",
                  cursor: "pointer",
                  border: "1px solid dimgrey",
                  padding: "4px 10px",
                  borderRadius: 4,
                  fontWeight: "bold",
                }}
              >
                Terminos y condiciones - Políticas de protección de datos -
                Preguntas frecuentes
              </span>
            </Grid>
          </Grid>
        </Grid>
      </center>
      {/* ################ DIALOG DELETE ################### */}
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={handleCloseDelete()}
        aria-labelledby="customized-dialog-title"
        open={openDelete}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          {" "}
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} style={{ paddingTop: 50 }}>
              <center>
                <div className={classes.titleCardFilter}>
                  ¿Desea eliminar esta TARJETA?
                </div>
                <br></br>
                <ButtonStyle0 onClick={deleteCard()}>Eliminar</ButtonStyle0>
              </center>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDelete()}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
      {/* ################ DIALOG ACCEPT TERMS ################### */}
      {openAcceptTerms && (
        <Dialog
          fullWidth
          maxWidth="md"
          aria-labelledby="customized-dialog-title"
          open={openAcceptTerms}
          keepMounted
          scroll="body"
          PaperProps={{
            sx: {
              borderRadius: 6,
            },
          }}
        >
          <DialogContent dividers className={classes.styleDialogContent}>
            <center>
              <Grid container spacing={2} className={classes.containerProfile}>
                <Grid item xs={12} sm={12}>
                  {error && <Alert severity="error">{mensageSystem}</Alert>}
                </Grid>
                {error ? (
                  <Grid item xs={12} sm={12} sx={{ textAlign: "left", mb: 3 }}>
                    <center>
                      <img
                        alt="loaderGif"
                        src={noDataImg}
                        style={{ width: 300, marginTop: 50 }}
                      />
                      <br></br>
                      <b style={{ fontSize: 18, margin: "5px 0 70px 0" }}>
                        No hay registros para mostrar
                      </b>
                    </center>
                  </Grid>
                ) : (
                  <>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      sx={{ textAlign: "left", mb: 3 }}
                    >
                      <div className={classes.titleCardFilter}>
                        Aceptar terminos y condiciones y Políticas de protección
                        de datos
                      </div>
                      <div className={classes.lineBottom}></div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{
                        maxHeight: "300px",
                        overflow: "auto",
                        border: "1px solid #ccc",
                      }}
                    >
                      <Fragment>
                        <CssBaseline />
                        <Toolbar
                          id="back-to-top-anchor"
                          sx={{ background: "#FAFAFA" }}
                        />
                        <Box
                          sx={{
                            textAlign: "justify",
                            background: "#FAFAFA",
                            padding: 1,
                            fontSize: 14,
                          }}
                        >
                          <b>ACEPTACIÓN DE TÉRMINOS Y CONDICIONES</b>
                          <br></br>
                          <br></br>• Todo servicio deberá ser coordinado
                          exclusivamente a través de la central de atención
                          telefónica al número: 096-387-1014. Cualquier atención
                          no autorizada o no registrada por dicho canal no
                          contará con cobertura ni derecho a reembolso.
                          <br></br>• La vigencia del servicio está sujeta al
                          cumplimiento puntual de los pagos por parte del
                          cliente, ya sea en modalidad de cuotas mensuales o
                          pago total anticipado.
                          <br></br>• El contrato podrá mantenerse vigente por
                          hasta un máximo de sesenta (60) días en caso de mora,
                          únicamente respecto de la relación contractual, más{" "}
                          <b>no respecto del servicio</b>, el cual permanecerá
                          suspendido hasta la regularización de los pagos.{" "}
                          <br></br>• Tiempo de carencia 30 días contados desde
                          la fecha de contratación del servicio.
                          <br></br>• No se cubrirán tratamientos odontológicos
                          ya iniciados al momento de la contratación del
                          servicio.
                          <br></br>• No se cubrirán atenciones fuera de la red
                          de prestadores ni solicitudes de reembolso.
                          <br></br>• No se cubrirán retratamientos, salvo que se
                          indique expresamente lo contrario en el recuadro de
                          coberturas.
                          <br></br>• La adhesión al presente servicio es libre y
                          voluntaria.
                          <br></br>• El Servicio de Contact Center será operado
                          por <b>ÚSAME – INNOVATECH S.A.</b> en calidad de{" "}
                          <b>Responsable del Tratamiento</b> de los datos
                          personales conforme lo establecido en la Ley Orgánica
                          de Protección de Datos Personales (LOPDP) y su
                          Reglamento. Por otra parte, la atención odontológica
                          general y especializada será prestada por la Red de
                          Clínicas Confident a nivel nacional, en calidad de
                          Responsable del Tratamiento de datos personales. Cada
                          una de las partes será proporcionalmente responsable
                          conforme los datos personales que recoja y recopile
                          para el desarrollo de los tratamientos necesarios para
                          el correcto desempeño de sus funciones y cumplimiento
                          de obligaciones como proveedores de servicios.
                          <br></br>• El cliente declara que los recursos
                          económicos utilizados provienen de fuentes lícitas.
                          <br></br>• El cliente declara haber sido debidamente
                          informado sobre las condiciones, cobertura, costos,
                          excepciones, vigencia y límites del servicio
                          contratado.
                          <br></br>• El presente contrato es válido en todo el
                          territorio de la República del Ecuador y ampara al
                          titular, sus dependientes y/o afiliados adicionales
                          debidamente registrados.
                          <br></br>• El titular del contrato deberá ser mayor de
                          edad al momento de la firma del mismo.
                          <br></br>• El titular es responsable de mantener sus
                          datos actualizados, para efectos de notificación y
                          comunicación.
                          <br></br>• Para el ingreso de los dependientes y/o,
                          afiliados adicionales, en el plan contratado, la edad
                          mínima para el ingreso es a partir de los seis (6)
                          meses de edad. La permanencia será INDEFINIDA siempre
                          y cuando se mantengan los pagos al día.
                          <br></br>• Cuando el ingreso es del Núcleo familiar
                          (Titular + cónyuge + hijos), no existe límite de
                          beneficiarios.
                          <br></br>• Cuando el ingreso es Titular + Familia
                          (Padres, hermanos y suegros), el número máximo de
                          beneficiarios es de cuatro (4), incluyendo el Titular.
                          <br></br>• Todas las asistencias que no se encuentran
                          dentro del cuadro de cobertura, cuentan con un
                          descuento por parte del prestador y quedan a
                          disposición del cliente el tomar y cancelar su
                          respectivo valor.
                          <br></br>• Todo servicio que NO se encuentre
                          estipulado expresamente en el presente contrato, no
                          será cubierto. Aquellos procedimientos no incluidos en
                          el cuadro de coberturas podrán ser ofrecidos con
                          descuento por parte del prestador, quedando a
                          discreción del CLIENTE su aceptación y pago directo.
                          <br></br>• El presente contrato tiene una vigencia
                          indefinida y se renovará automáticamente mientras el
                          cliente se mantenga al día en sus obligaciones.
                          <br></br>• El CLIENTE podrá dar por terminado el
                          presente contrato en cualquier momento, sin penalidad,
                          mediante solicitud escrita dirigida a ÚSAME INNOVATECH
                          S.A., con una anticipación mínima de treinta (30) días
                          calendario. La solicitud deberá contener firma del
                          titular, copia de cédula y ser enviada a través de los
                          canales oficiales (correo electrónico o entrega
                          física). Una vez recibida y validada, la prestación de
                          servicios se mantendrá hasta el último día del mes
                          calendario en curso, y si existiera un pago
                          anticipado, se devolverá el valor no devengado en
                          forma proporcional, deduciendo los costos financieros
                          y administrativos correspondientes.
                          <br></br>• La terminación del contrato afectará
                          automáticamente a todos los dependientes o afiliados
                          registrados, salvo que alguno de ellos asuma la
                          titularidad conforme a los procedimientos establecidos
                          por ÚSAME INNOVATECH S.A. La empresa confirmará por
                          escrito la finalización del contrato y el estado de
                          cuenta en un plazo máximo de cinco (5) días hábiles
                          desde la recepción válida de la solicitud. No se
                          reconocerán devoluciones por periodos ya transcurridos
                          ni por servicios no utilizados dentro del mes en
                          curso.
                          <br></br>• Autorización de Débito Mensual. El Cliente
                          autoriza expresamente a ÚSAME INNOVATECH S.A., a
                          debitar de manera automática el importe
                          correspondiente a la suscripción o servicio
                          contratado, según el plan elegido, de la cuenta
                          bancaria o tarjeta registrada al momento de la
                          contratación.
                          <br></br>• Este débito se realizará de forma mensual,
                          en la fecha acordada, hasta tanto el cliente decida
                          cancelar el servicio conforme a las políticas de
                          cancelación vigentes. El Cliente declara estar
                          debidamente informado del valor a ser debitado y
                          presta su consentimiento expreso para dicha operación
                          recurrente.
                          <br></br>• Cualquier modificación en el valor del
                          servicio será notificada previamente al cliente, quien
                          tendrá la posibilidad de aceptar los nuevos términos o
                          cancelar el servicio antes de que se efectúe el
                          siguiente débito.
                          <br></br>• Si el cliente presenta información falsa o
                          inexacta en el proceso de contratación, perderá de
                          forma automática e irrevocable el derecho a los
                          servicios, asumiendo responsabilidad civil y/o penal
                          por los perjuicios que dicha conducta genere.
                          <br></br>• EL CLIENTE autoriza libre, expresa e
                          informadamente a ÚSAME INNOVATECH S.A. (“ÚSAME”, en
                          adelante) a utilizar los datos personales
                          proporcionados conforme las finalidades previstas en
                          este contrato y su política de privacidad. En caso de
                          datos personales de terceros, EL CLIENTE garantiza que
                          cuenta con la autorización de los terceros cuyos datos
                          proporciona para efectos de cobertura, con el objetivo
                          de establecer contacto por medio de llamadas
                          telefónicas, mensajes de texto, correo electrónico, o
                          cualquier otro medio que sea considerado óptimo para
                          el cumplimiento del objeto.
                          <br></br>
                          <br></br>
                          <b>PROTECCIÓN DE DATOS PERSONALES</b>
                          <br></br>
                          <br></br>• De conformidad con lo previsto en la Ley
                          Orgánica de Protección de Datos, EL CLIENTE libre,
                          voluntaria y expresamente, consiente y autoriza a
                          ÚSAME INNOVATECH S.A.
                          <br></br>• (ÚSAME) para que utilice y disponga de los
                          datos personales que ELCLIENTE le proporcione a través
                          de este contrato o por cualquier medio escrito,
                          informático o digital.
                          <br></br>• EL CLIENTE proporcionará los datos
                          personales de los terceros interesados en acceder al
                          servicio a fin de que sean considerados dentro de la
                          cobertura de este, con la observación de que los
                          terceros afiliados deberán firmar la autorización para
                          el tratamiento de sus datos personales para acceder al
                          servicio prestado por la Red de Clínicas Confident a
                          nivel nacional.
                          <br></br>• ÚSAME declara expresamente que cumple a
                          cabalidad con la normativa vigente en materia de
                          protección de datos personales para el tratamiento de
                          los datos personales de sus clientes.
                          <br></br>• ÚSAME declara expresamente que reconoce los
                          derechos consagrados al titular de los datos
                          personales, en la normativavigente en materia de
                          protección de datos personales.
                          <br></br>• ÚSAME declara que en caso de requiriese
                          información personal adicional de sus clientes para la
                          prestación efectiva delservicio, solicitará la
                          autorización correspondiente para el tratamiento de la
                          información de carácter personal de éstos.
                          <br></br>• ÚSAME se compromete a tratar los datos con
                          la finalidad exclusiva de la prestación del servicio.
                          Una vez concluida la prestación del servicio, se
                          compromete a destruir, en la medida que lo permita la
                          tecnología, los datos proporcionados, asícomo el
                          resultado de cualquier elaboración de los mismos y los
                          soportes o documentos en que se halle recogida la
                          información o, en su caso, a devolvérselos a EL
                          CLIENTE. La conservación y eliminación y/o devolución
                          de los datos personales se realizará en cumplimiento
                          de los plazos que establece la normativa
                          correspondiente.
                          <br></br>• De conformidad con la normativa vigente,
                          ÚSAME asume la obligación de proteger los datos
                          personales a los que accedan con ocasión del contrato
                          del servicio. Como consecuencia de esta obligación
                          legal, entre otras, adoptará las medidas de seguridad
                          de tipo técnico, organizativo y de cualquier otra
                          índole, acorde a la naturaleza y criticidad de la
                          información personal objeto de tratamiento.
                          <br></br>• ÚSAME notificará a los titulares cualquier
                          vulneración de sus datos personales conforme a los
                          plazos establecidos en la LOPDP y su Reglamento.
                          <br></br>• La aceptación del presente contrato
                          conlleva la aceptación expresa de la política de
                          privacidad de ÚSAME disponible en su página web
                          oficial.
                          <br></br>
                          <br></br>
                          El titular de los datos acepta y emite su
                          consentimiento unilateral de manera libre y voluntaria
                          para el tratamiento de sus datos personales para que
                          sean: recolectados a través de nuestros canales
                          electrónicos o por cualquier medio, almacenados,
                          procesados, transmitidos y eliminados o para ser
                          objeto de cualquier tratamiento o conjunto de
                          tratamientos a realizar, ya sea por procedimientos
                          técnicos de carácter automatizado, parcialmente
                          automatizado o no automatizados por el Comercio o su
                          delegado, con la finalidad de identificar, actualizar
                          sus datos y ofrecerle servicios y/o productos a través
                          de los canales digitales o cualquier otro medio.
                          <br></br>
                          <br></br>
                          La transmisión y almacenamiento de la información
                          recopilada por el Comercio o su delegado, será
                          realizada en la infraestructura que este administre,
                          dentro o fuera del territorio ecuatoriano. Esta
                          infraestructura puede ser implementada en servidores
                          físicos o en la nube de proveedores que cuenten con
                          las debidas certificaciones internacionales para el
                          tratamiento de Seguridad de la Información.
                          <br></br>
                          <br></br>
                          Adicionalmente, mediante la presente el titular de los
                          datos declara conocer y aceptar el Aviso de Política
                          de Privacidad de Placetopay en la cual se indican sus
                          derechos, datos tratados y las actividades comerciales
                          de los aliados, así como otros datos de interés
                          respecto a la protección de datos personales, que se
                          encuentran detallados en el sitio web de Placetopay en
                          la ruta
                          https://www.placetopay.com/web/politicas-de-privacidad/
                          , mediante la cual, se podrá solicitar la gestión de
                          derechos o consentimientos.
                          <br></br>
                          <br></br>
                          El Comercio o su delegado notificará sobre las
                          actualizaciones del Aviso de Política de Privacidad
                          antes mencionado por medio de los diferentes canales
                          digitales.
                          <br></br>
                          <br></br>
                          <b>PREGUNTAS FRECUENTES SOBRE PAGOS ELECTRÓNICOS</b>
                          <br></br>
                          <br></br>
                          En este documento, usted encontrará una sección de
                          preguntas y respuestas que le ayudará a sus usuarios a
                          aclarar sus dudas sobre los pagos electrónicos
                          procesados a través de Placetopay. Recuerde que debe
                          incluirlas en su sitio web.
                          <br></br>
                          <br></br>
                          <b>1. ¿Qué es Placetopay? </b>
                          Placetopay es la plataforma de pagos electrónicos que
                          usa ÚSAME INNOVATECH S.A. para procesar en línea las
                          transacciones generadas en la tienda virtual con las
                          formas de pago habilitadas para tal fin.
                          <br></br>
                          <br></br>
                          <b>2. ¿Cómo puedo pagar? </b>
                          En la tienda virtual de ÚSAME, usted podrá realizar su
                          pago con los medios habilitados para tal fin. Usted,
                          de acuerdo con las opciones de pago escogidas por el
                          comercio, podrá pagar a través Diners, Discover, Visa
                          y MasterCard; de todos los bancos con pago corriente y
                          pagos diferidos, únicamente las tarjetas emitidas por
                          Banco Pichincha, Diners, Loja, BGR y Manabí.
                          <br></br>
                          <br></br>
                          <b>
                            3. ¿Es seguro ingresar mis datos bancarios en este
                            sitio web?{" "}
                          </b>
                          Para proteger tus datos ÚSAME delega en Placetopay la
                          captura de la información sensible. Nuestra plataforma
                          de pagos cumple con los más altos estándares exigidos
                          por la norma internacional PCI DSS de seguridad en
                          transacciones con tarjeta de crédito. Además, tiene
                          certificado de seguridad SSL expedido por GeoTrust una
                          compañía Verisign, el cual garantiza comunicaciones
                          seguras mediante la encriptación de todos los datos
                          hacia y desde el sitio; de esta manera, te podrás
                          sentir seguro a la hora de ingresar la información de
                          su tarjeta.
                          <br></br>
                          <br></br>
                          Durante el proceso de pago, en el navegador se muestra
                          el nombre de la organización autenticada, la autoridad
                          que lo certifica y la barra de dirección cambia a
                          color verde. Estas características son visibles de
                          inmediato y dan garantía y confianza para completar la
                          transacción en Placetopay.
                          <br></br>
                          <br></br>
                          Placetopay también cuenta con el monitoreo constante
                          de McAfee Secure y la firma de mensajes electrónicos
                          con Certicámara.
                          <br></br>
                          <br></br>
                          Placetopay es una marca de la empresa colombiana EGM
                          Ingeniería Sin Fronteras S.A.S.
                          <br></br>
                          <br></br>
                          <b>
                            4. ¿Puedo realizar el pago cualquier día y a
                            cualquier hora?{" "}
                          </b>
                          Sí, en ÚSAME podrás realizar tus compras en línea los
                          7 días de la semana, las 24 horas del día a sólo un
                          clic de distancia.
                          <br></br>
                          <br></br>
                          <b>5. ¿Puedo cambiar la forma de pago?</b>
                          Si aún no has finalizado tu pago, podrás volver al
                          paso inicial y elegir la forma de pago que prefieras.
                          Una vez finalizada la compra no es posible cambiar la
                          forma de pago.
                          <br></br>
                          <br></br>
                          <b>
                            6. ¿Pagar electrónicamente tiene algún valor para mí
                            como comprador?{" "}
                          </b>
                          No, los pagos electrónicos realizados a través de
                          Placetopay no generan costos adicionales para el
                          comprador.
                          <br></br>
                          <br></br>
                          <b>
                            7. ¿Qué debo hacer si mi transacción no concluyó?
                          </b>
                          En primera instancia deberás revisar si llegó un mail
                          de confirmación del pago en tu cuenta de correo
                          electrónico (la inscrita en el momento de realizar el
                          pago), en caso de no haberlo recibido, deberás
                          contactar a hola@usamebpo.com para confirmar el estado
                          de la transacción.
                          <br></br>
                          <br></br>
                          En caso de que tu transacción haya declinado, debes
                          verificar si la información de la cuenta es válida,
                          está habilitada para compras no presenciales y si
                          tienes cupo o saldo disponible. Si después de esto
                          continua con la declinación debes comunicarte con
                          Úsame. En última instancia, puedes remitir tu
                          solicitud a servicioposventa@placetopay.ec.
                          <br></br>
                          <br></br>
                          <b>
                            8. ¿Qué debo hacer si no recibí el comprobante de
                            pago?
                          </b>
                          Por cada transacción aprobada a través de Placetopay,
                          recibirás un comprobante del pago con la referencia de
                          compra en la dirección de correo electrónico que
                          indicaste al momento de pagar. Si no lo recibes,
                          podrás contactar a la línea 023958950 / 0963166600 o
                          al correo electrónico hola@usamebpo.com, para
                          solicitar el reenvío del comprobante a la misma
                          dirección de correo electrónico registrada al momento
                          de pagar. En última instancia, puedes remitir tu
                          solicitud a servicioposventa@placetopay.ec.
                          <br></br>
                          <br></br>
                          <b>
                            9. No me llegó el producto que compré ¿qué hago?
                          </b>
                          Debes verificar si la transacción fue exitosa en tu
                          extracto bancario. En caso de ser así, debes revisar
                          nuestras políticas de envío en el sitio web
                          https://usamebpo.com/politica-de-privacidad/ para
                          identificar los tiempos de entrega.
                        </Box>
                      </Fragment>
                    </Grid>
                    <Grid item xs={12} md={8} sx={{ paddingTop: 20 }}>
                      {!accept && (
                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={state.YES_termsConditions}
                                onChange={handleChangeCheckbox}
                                name="YES_termsConditions"
                              />
                            }
                            label={
                              <span style={{ fontSize: 14 }}>
                                Sí acepto los términos y condiciones y firmo
                                digitalmente el certificado.
                              </span>
                            }
                            sx={{
                              color: blackColor,
                              display: "flex", // Usa flexbox para un control preciso
                              justifyContent: "flex-start", // Alinea los elementos al principio
                              alignItems: "center", // Alinea verticalmente los elementos
                            }}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={state.YES_dataProtectionPolicies}
                                onChange={handleChangeCheckbox}
                                name="YES_dataProtectionPolicies"
                              />
                            }
                            label={
                              <span style={{ fontSize: 14 }}>
                                Sí acepto las políticas de protección de datos.
                              </span>
                            }
                            sx={{
                              color: blackColor,
                              display: "flex", // Usa flexbox para un control preciso
                              justifyContent: "flex-start", // Alinea los elementos al principio
                              alignItems: "center", // Alinea verticalmente los elementos
                            }}
                          />
                        </FormGroup>
                      )}
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Grid container>
                        <Grid item xs={12} md={12}>
                          <ButtonStyle0
                            type="submit"
                            onClick={submitAccept}
                            style={{ float: "right", marginTop: 20 }}
                            disabled={
                              state.YES_termsConditions &&
                              state.YES_dataProtectionPolicies
                                ? false
                                : true
                            }
                          >
                            Aceptar
                          </ButtonStyle0>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
            </center>
          </DialogContent>
        </Dialog>
      )}
      {openFrequentQuestion && (
        <FrequentQuestions
          open={openFrequentQuestion}
          exit={handleCloseFrequentQuestion}
        />
      )}
      {openNew && (
        <NewCardLink
          open={openNew}
          row={rows}
          exit={handleCloseOpenNew}
          callBack={RowsDatas}
        />
      )}
    </Fragment>
  );
}
